<template>
    <div id="mailingModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mailingTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="mailingTitle">Submitted by Mail</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <h4 v-if="document">{{ document.description }}</h4>
                    <div v-if="message" class="alert alert-danger alert-dismissible fade show" role="alert">
                        {{ message }}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="form-group mt-3">               
                        <label for="mailed_date">Date Mailed to Payer</label>
                        <input id="mailed_date" type="date" :class="['form-control', {'is-invalid': errors['mailed_date']}]" name="mailed_date" :max="today" v-model="mailedDate">
                        <span v-if="errors['mailed_date']" class="invalid-feedback ml-1" role="alert">
                            <strong v-text="errors['mailed_date']"></strong>
                        </span>                        
                        <div v-if="document && !document.has_associated_mailing && isValidDate(mailedDate)" class="alert alert-primary mt-2" role="alert">
                            <div class="d-flex align-items-start">
                                <i class="fas fa-info-circle fa-2x mr-3"></i>
                                <div>
                                    You can upload a scanned copy of the mailed submission documents using the Upload
                                    Associated Documents button selecting Mailed CMS 1500 as the document type.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <label for="received_date" clss="mt-3">Date Received by Payer</label>
                        <input id="received_date" type="date" :class="['form-control', {'is-invalid': errors['received_date']}]" name="received_date" :max="today" v-model="receivedDate">
                        <span v-if="errors['received_date']" class="invalid-feedback ml-1" role="alert">
                            <strong v-text="errors['received_date']"></strong>
                        </span>                              
                        <div v-if="document && !document.has_associated_receipt && isValidDate(receivedDate)" class="alert alert-primary mt-2" role="alert">
                            <div class="d-flex align-items-start">
                                <i class="fas fa-info-circle fa-2x mr-3"></i>
                                <div>
                                    You can upload a scanned copy of the return receipt using the Upload
                                    Associated Documents button selecting Return Receipt as the document type.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-primary" @click="save()" :disabled="disable">Save</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>   
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {

        return {
            document: null,
            mailedDate: null,
            receivedDate: null,
            errors: [],
            message: null
        }
    },
    computed: {
        today: function () {
            return moment().format('YYYY-MM-DD');
        },
        disable: function () {
            return !this.mailedDate && !this.receivedDate;
        }
    },
    methods: {
        show: function (document) {

            this.document = document;

            this.mailedDate = document.mailed_date;
            this.receivedDate = document.received_date;
            this.errors = [];
            this.message = null;
            
            $('#mailingModal').modal('show');
        },
        isValidDate: function (value) {
            return (value && !isNaN(new Date(value)));
        },
        save: function () {

            if (this.validate()) {

                axios.post('/ajax/provider/documents/' + this.document.id + '/mailed', {
                    mailed_date: this.mailedDate,
                    received_date: this.receivedDate
                })
                .then(response => {

                    $('#mailingModal').modal('hide');
                })
                .catch(error => {

                    this.message = error.response.data.message;
                });
            }
        },
        validate: function () {

            let retval = true;

            let mailed = new Date(this.mailedDate).getTime();
            let received = new Date(this.receivedDate).getTime();
            let today = new Date(this.today).getTime();

            // validate mailed to payer date
            if ((mailed > today) || (mailed && received && (mailed > received))) {

                if (mailed > today) {
                    this.$set(this.errors, 'mailed_date', 'Date mailed to payer cannot be a future date.');
                }
                else if (mailed > received) {
                    this.$set(this.errors, 'mailed_date', 'Date mailed to payer cannot be after date received by payer.');
                }

                retval = false;
            }
            else {

                this.$set(this.errors, 'mailed_date', null);
            }

            // validate reveived by payer date
            if ((received > today) || (mailed && received && (received < mailed))) {

                if (received > today) {
                    this.$set(this.errors, 'received_date', 'Date received by payer connot be a future date.');
                }
                else if (received < mailed) {
                    this.$set(this.errors, 'received_date', 'Date received by payer connot be before date mailed to payer.');
                }

                retval = false;
            }
            else {

                this.$set(this.errors, 'received_date', null);
            }

            return retval;
        }
    },
    created() {

        eventHub.$on('show-mailing-upload', this.show);
    },
    beforeDestroy() {

        eventHub.$off('show-mailing-upload');
    }    
}
</script>

<style scoped>

</style>